import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getVehicleSpareKeys,
  getVehicleSpareKey,
  createVehicleSpareKey,
  updateVehicleSpareKey,
  deleteVehicleSpareKey,
} from "api/vehicleSpareKeyApi"

export const VEHICLE_SPARE_KEY_QUERY_KEY = "vehicle-spare-keys"

export const useVehicleSpareKeys = (params = {}, enabled = true) =>
  usePaginatedResource(
    VEHICLE_SPARE_KEY_QUERY_KEY,
    getVehicleSpareKeys,
    params,
    enabled
  )

export const useVehicleSpareKey = (id, enabled = true) =>
  useResourceItem(
    VEHICLE_SPARE_KEY_QUERY_KEY,
    getVehicleSpareKey,
    id,
    enabled
  )

export const useCreateVehicleSpareKey = () =>
  useCreateResource(createVehicleSpareKey, VEHICLE_SPARE_KEY_QUERY_KEY)

export const useEditVehicleSpareKey = () =>
  useEditResource(updateVehicleSpareKey, VEHICLE_SPARE_KEY_QUERY_KEY)

export const useDeleteVehicleSpareKey = () =>
  useDeleteResource(deleteVehicleSpareKey, VEHICLE_SPARE_KEY_QUERY_KEY)
